// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MediaGalleryImage__container-a69f1c {
  margin-inline-start: auto;
  margin-inline-end: auto;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.MediaGalleryImage__image-f1ea29 {
  max-width: 100%;
  height: auto;
  max-height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/main/components/MediaGallery/MediaGalleryContent/MediaGalleryFile/MediaGalleryImage/MediaGalleryImage.styles.m.css"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,eAAA;EACA,YAAA;EACA,gBAAA;AACF","sourcesContent":[".container {\n  margin-inline-start: auto;\n  margin-inline-end: auto;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.image {\n  max-width: 100%;\n  height: auto;\n  max-height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MediaGalleryImage__container-a69f1c`,
	"image": `MediaGalleryImage__image-f1ea29`
};
module.exports = ___CSS_LOADER_EXPORT___;
